<form
  *ngIf="_storageAccount"
  [formGroup]="form">
  <ng-container *ngIf="viewMode === 'modal'">
    <ng-container [ngTemplateOutlet]="displayName"></ng-container>

    <ng-container [ngTemplateOutlet]="createNewGroup"></ng-container>

    <ng-container [ngTemplateOutlet]="inputGroup"></ng-container>

    <ng-container [ngTemplateOutlet]="manualEnteringLoader"></ng-container>

    <ng-container [ngTemplateOutlet]="objectLock"></ng-container>

    <ng-container [ngTemplateOutlet]="s3Accelerator"></ng-container>

    <ng-container [ngTemplateOutlet]="reuseAccountRulesTemplate"></ng-container>

    <ng-container [ngTemplateOutlet]="companies"></ng-container>
  </ng-container>

  <ng-container *ngIf="viewMode === 'wizard'">
    <mbs-card class="card-form">
      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="displayName"></ng-container>
      </mbs-card-group>

      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="createNewGroup"></ng-container>
        <ng-container [ngTemplateOutlet]="inputGroup"></ng-container>
        <ng-container [ngTemplateOutlet]="objectLock"></ng-container>
        <ng-container [ngTemplateOutlet]="s3Accelerator"></ng-container>
      </mbs-card-group>

      <mbs-card-group>
        <ng-container [ngTemplateOutlet]="companies"></ng-container>
      </mbs-card-group>
    </mbs-card>
  </ng-container>
</form>

<ng-template #displayName>
  <div class="mbs-form-group">
    <mbs-input
      [attr.data-e2e]="e2eLocators.displayNameControl"
      [boldLabel]="true"
      [formControl]="displayNameControl"
      [label]="'shared:modals.addDestinationBucket.destinationDisplayName' | i18next: { format: 'capitalize' }"
      [placeholder]="'shared:modals.addDestinationBucket.displayNamePlaceholder' | i18next: { format: 'capitalize' }"
      [showRequiredMark]="false"></mbs-input>
  </div>
</ng-template>

<ng-template #createNewGroup>
  <ng-container *ngIf="showSwitcher()">
    <div class="mbs-form-group">
      <mbs-group-button
        class="w-100"
        customClasses="w-100">
        <mbs-button
          class="flex-basis-50"
          customClasses="w-100 justify-content-center"
          [active]="createNew.value"
          [attr.data-e2e]="e2eLocators.createNewBtn"
          [type]="'secondary'"
          (click)="createNew.patchValue(true)">
          {{ 'shared:modals.addDestinationBucket.newBucket' | i18next: { type: bucketTypeName } }}
        </mbs-button>
        <mbs-button
          class="flex-basis-50"
          customClasses="w-100 justify-content-center"
          [active]="!createNew.value"
          [attr.data-e2e]="e2eLocators.existingBucketBtn"
          [type]="'secondary'"
          (click)="createNew.patchValue(false)">
          {{ 'shared:modals.addDestinationBucket.existingBucket' | i18next: { type: bucketTypeName } }}
        </mbs-button>
      </mbs-group-button>
    </div>
  </ng-container>
</ng-template>

<ng-template #inputGroup>
  <div class="mbs-form-group">
    <div class="form-row">
      <ng-container *ngIf="createNew.value; else existingBucket">
        <div class="col-6">
          <mbs-input
            [attr.data-e2e]="e2eLocators.bucketNameControl"
            [boldLabel]="true"
            [formControl]="bucketNameControl"
            [label]="'shared:modals.addDestinationBucket.bucketName' | i18next: { format: 'capitalize', type: bucketTypeName }"
            [placeholder]="
              'shared:modals.addDestinationBucket.bucketNamePlaceholder' | i18next: { format: 'capitalize', type: bucketTypeName }
            "
            [showRequiredMark]="false">
            <ng-container appendLabel>
              <span
                class="ico ico-info-circle ml-2 cursor-help text-info"
                container="body"
                tooltipClass="tooltip-xl"
                [ngbTooltip]="rules"
                [placement]="'right'"></span>
              <ng-template #rules>
                <ul class="text-start m-0 p-3">
                  <li
                    *ngFor="let item of bucketNameRules; let last = last"
                    class="text-md ml-2 mb-1 pb-0">
                    {{ item }}<br *ngIf="!last" />
                  </li>
                </ul>
              </ng-template>
            </ng-container>
          </mbs-input>
        </div>

        <ng-container *ngIf="_storageAccount?.supportedStorageClass">
          <div class="col-6">
            <!-- 'body', not '.modal-content': this form also renders inside the add storage account wizard, which can itself be opened on top of another modal - querySelector would then resolve to the outer window and hide the dropdown -->
            <mbs-select
              bindLabel="name"
              [appendTo]="'body'"
              [attr.data-e2e]="e2eLocators.storageClassControl"
              [boldLabel]="true"
              [clearable]="false"
              [formControl]="storageClassControl"
              [items]="storageClasses"
              [label]="'shared:modals.addDestinationBucket.storageClass' | i18next: { format: 'capitalize' }"
              [placeholder]="'shared:modals.addDestinationBucket.storageClassPlaceholder' | i18next: { format: 'capitalize' }"
              [showRequiredMark]="false"></mbs-select>
          </div>
        </ng-container>

        <ng-container *ngIf="_storageAccount?.supportedBucketLocation">
          <div
            class="col-6"
            [class.mt-3]="googleCloudAccounts.includes(_storageAccount.storageType)">
            <mbs-select
              bindLabel="displayName"
              [appendTo]="'body'"
              [attr.data-e2e]="e2eLocators.regionControl"
              [boldLabel]="true"
              [clearable]="false"
              [clearUnavailableSelection]="true"
              [formControl]="regionControl"
              [items]="regions"
              [label]="
                (googleCloudAccounts.includes(_storageAccount?.storageType) ? 'shared:captions.location' : 'shared:storages.region')
                  | i18next: { format: 'capitalize' }
              "
              [loading]="specificGCDataLoading"
              [placeholder]="
                (googleCloudAccounts.includes(_storageAccount?.storageType)
                  ? 'shared:modals.addDestinationBucket.locationPlaceholder'
                  : 'shared:placeholders.region'
                ) | i18next: { format: 'capitalize' }
              "
              [showRequiredMark]="false"></mbs-select>
          </div>
        </ng-container>

        <ng-container *ngIf="googleCloudAccounts.includes(_storageAccount?.storageType)">
          <div class="col-6 mt-3">
            <mbs-select
              bindLabel="displayName"
              [appendTo]="'body'"
              [attr.data-e2e]="e2eLocators.googleDestinationSubregionControl"
              [boldLabel]="true"
              [clearable]="false"
              [formControl]="googleDestinationSubregionControl"
              [items]="googleSubregions"
              [label]="'shared:modals.addDestinationBucket.regionalLocation' | i18next: { format: 'capitalize' }"
              [loading]="specificGCDataLoading && googleDestinationSubregionControl.enabled"
              [placeholder]="'shared:modals.addDestinationBucket.regionalLocationPlaceholder' | i18next: { format: 'capitalize' }"
              [showRequiredMark]="false"></mbs-select>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #existingBucket>
        <ng-container *ngIf="_storageAccount?.supportedExternalBucket && !blockForm">
          <div class="mbs-form-group col-12">
            <mbs-switcher
              [attr.data-e2e]="e2eLocators.isExternalBucketControl"
              [boldLabel]="true"
              [formControl]="isExternalBucketControl"
              [label]="'shared:modals.addDestinationBucket.externalBucketTitle' | i18next: { type: bucketTypeName }">
              <ng-template switcherDescription>
                <div class="add-destination-form_switcher-description text-sm">
                  {{ 'shared:modals.addDestinationBucket.externalBucketDescription' | i18next }}
                </div>
              </ng-template>
            </mbs-switcher>
          </div>
        </ng-container>

        <ng-container *ngIf="!isManualBucketEntering() && !blockForm; else plainInput">
          <div class="col-12">
            <mbs-select
              bindLabel="bucketName"
              bindValue="bucketName"
              [appendTo]="'body'"
              [attr.data-e2e]="e2eLocators.bucketNameControl"
              [boldLabel]="true"
              [clearable]="false"
              [formControl]="bucketNameControl"
              [items]="bucketsNames"
              [label]="'shared:modals.addDestinationBucket.bucketName' | i18next: { format: 'capitalize', type: bucketTypeName }"
              [loading]="bucketsLoading() || bucketLoading()"
              [placeholder]="
                'shared:modals.addDestinationBucket.selectBucketName' | i18next: { format: 'capitalize', type: bucketTypeName }
              "
              [showRequiredMark]="false"></mbs-select>
          </div>
        </ng-container>

        <ng-template #plainInput>
          <mbs-alert
            *ngIf="!isExternalBucketControl.value && !blockForm"
            [icon]="true"
            [type]="mbsPopupType.warning">
            <div [innerHTML]="getManualBucketEnteringAlertText()"></div>
          </mbs-alert>

          <div class="col-12">
            <mbs-input
              [attr.data-e2e]="e2eLocators.bucketNameControl"
              [boldLabel]="true"
              [disabledSelf]="manualBucketLoading"
              [formControl]="bucketNameControl"
              [label]="
                (isExternalBucketControl?.value
                  ? 'shared:modals.addDestinationBucket.externalBucketName'
                  : 'shared:modals.addDestinationBucket.bucketName'
                ) | i18next: { format: 'capitalize', type: bucketTypeName }
              "
              [placeholder]="'shared:modals.addDestinationBucket.enterBucketName' | i18next: { format: 'capitalize', type: bucketTypeName }"
              [showRequiredMark]="false">
            </mbs-input>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #manualEnteringLoader>
  <ng-container *ngIf="manualBucketLoading">
    <div class="d-flex justify-content-center mt-4">
      <span class="loader loader-lg"></span>
    </div>
  </ng-container>
</ng-template>

<ng-template #objectLock>
  <div class="mbs-form-group">
    @if (createNew.value) {
      @if (_storageAccount.isDefaultObjectLockSupportedForNew || _storageAccount.isGfsObjectLockSupported) {
        <div class="mbs-form-group">
          <ng-container
            [ngTemplateOutlet]="title"
            [ngTemplateOutletContext]="{
              message: 'shared:modals.addDestinationBucket.enabledOnStorage' | i18next,
              link: '/backup/about/object-lock/default#add'
            }"></ng-container>
        </div>

        @if (_storageAccount.isDefaultObjectLockSupportedForNew) {
          <ng-container [ngTemplateOutlet]="defaultOL"></ng-container>
        }
        @if (_storageAccount.isGfsObjectLockSupported) {
          <ng-container [ngTemplateOutlet]="gfsOL"></ng-container>
        }
      } @else {
        <ng-container [ngTemplateOutlet]="notSupported"></ng-container>
      }
    } @else {
      @if (!_storageAccount.isDefaultObjectLockSupportedForExisting && !_storageAccount.isGfsObjectLockSupported) {
        <ng-container [ngTemplateOutlet]="notSupported"></ng-container>
      } @else {
        <!-- Case then immutabilitySupported === null is a valid case -->
        @if (currentBucket() && currentBucket()?.immutabilitySupported !== false) {
          <div class="mbs-form-group">
            <ng-container
              [ngTemplateOutlet]="title"
              [ngTemplateOutletContext]="{
                message: currentBucket()?.immutabilitySupported
                  ? ('shared:modals.addDestinationBucket.enabledOnStorage' | i18next)
                  : ('shared:modals.addDestinationBucket.cantReadFromStorage' | i18next),
                link: currentBucket()?.immutabilitySupported
                  ? '/backup/about/object-lock/default#add'
                  : '/backup/about/object-lock/feature-types#storage',
                icon: currentBucket()?.immutabilitySupported ? null : 'fa fa-exclamation-triangle text-warning'
              }"></ng-container>
          </div>

          @if (_storageAccount.isDefaultObjectLockSupportedForExisting) {
            <ng-container [ngTemplateOutlet]="defaultOL"></ng-container>
          }

          @if (_storageAccount.isGfsObjectLockSupported && currentBucket()?.isGFSObjectLockSupported) {
            <ng-container [ngTemplateOutlet]="gfsOL"></ng-container>
          }
        }

        @if (currentBucket() && currentBucket()?.immutabilitySupported === false) {
          <div class="mbs-form-group">
            <ng-container
              [ngTemplateOutlet]="title"
              [ngTemplateOutletContext]="{
                message: 'shared:modals.addDestinationBucket.disabledOnStorage' | i18next,
                link: '/backup/about/object-lock/feature-types#storage'
              }"></ng-container>
          </div>
        }
      }
    }
  </div>

  <ng-template #defaultOL>
    <div class="mbs-form-group">
      <mbs-switcher
        [attr.data-e2e]="e2eLocators.defaultOLControl"
        [boldLabel]="false"
        [disabledSelf]="!(permissionsEnum.ManageImmutability | can: 'read') || blockForm"
        [formControl]="defaultOLControl"
        [label]="'shared:modals.addDestinationBucket.defaultObjectLockTitle' | i18next"
        [ngbTooltip]="
          (permissionsEnum.ManageImmutability | can: 'read')
            ? ''
            : ('shared:modals.addDestinationBucket.objectLockDisabledByPermission' | i18next)
        ">
        <ng-template switcherDescription>
          <div class="add-destination-form_switcher-description text-sm">
            <span class="mr-2">{{ 'shared:modals.addDestinationBucket.defaultObjectLockDescription' | i18next }}</span>
          </div>
        </ng-template>
      </mbs-switcher>

      <div class="mt-2 row ml-4 align-items-center">
        <div class="col-2">
          <mbs-number
            [attr.data-e2e]="e2eLocators.objectLockPeriodDaysControl"
            [boldLabel]="false"
            [disabledSelf]="!(permissionsEnum.ManageImmutability | can: 'read') || blockForm"
            [formControl]="objectLockPeriodDaysControl"
            [imaskOpts]="{
              mask: Number,
              scale: 0
            }"
            [max]="2147483647"
            [min]="0"></mbs-number>
        </div>
        <div class="col-auto pl-0">
          <mbs-input-label
            [label]="'shared:labels.days' | i18next: { format: 'capitalize' }"
            [labelClasses]="'mb-0'"></mbs-input-label>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #gfsOL>
    <div class="mbs-form-group">
      <mbs-switcher
        [attr.data-e2e]="e2eLocators.isGfsObjectLockEnabledControl"
        [boldLabel]="false"
        [disabledSelf]="!(permissionsEnum.ManageImmutability | can: 'read') || blockForm"
        [formControl]="gfsOLControl"
        [label]="'shared:modals.addDestinationBucket.gfsObjectLockTitle' | i18next"
        [ngbTooltip]="
          (permissionsEnum.ManageImmutability | can: 'read')
            ? ''
            : ('shared:modals.addDestinationBucket.objectLockDisabledByPermission' | i18next)
        ">
        <ng-template switcherDescription>
          <div class="add-destination-form_switcher-description text-sm">
            <span class="mr-1">{{ 'shared:modals.addDestinationBucket.gfsObjectLockDescription1' | i18next }}</span>
            <a
              helpLink="/backup/about/gfs/immutability#gfs"
              target="_blank"
              >GFS</a
            >
            <span class="ml-1">{{ 'shared:modals.addDestinationBucket.gfsObjectLockDescription2' | i18next }}</span>
          </div>
        </ng-template>
      </mbs-switcher>
    </div>
  </ng-template>

  <ng-template #notSupported>
    <ng-container
      [ngTemplateOutlet]="title"
      [ngTemplateOutletContext]="{
        message: 'shared:modals.addDestinationBucket.notSupported' | i18next,
        link: '/backup/about/object-lock/feature-types#storage'
      }"></ng-container>
  </ng-template>

  <ng-template #loader>
    <div class="d-flex justify-content-center mt-4">
      <span class="loader loader-lg"></span>
    </div>
  </ng-template>

  <ng-template
    #title
    let-icon="icon"
    let-link="link"
    let-message="message">
    <div [attr.data-e2e]="e2eLocators.objectLockTitle">
      <span class="text-l fw-bold mr-2">{{ 'shared:modals.addDestinationBucket.objectLockTitle' | i18next }}</span>

      @if (icon) {
        <span
          class="mr2"
          [ngClass]="icon"></span>
      }

      <span> - </span>
      <span class="text-sm mr-2">{{ message }}</span>
      <a
        class="text-sm"
        target="_blank"
        [helpLink]="link"
        >{{ 'shared:buttons.learnMore' | i18next }}</a
      >
    </div>
  </ng-template>
</ng-template>

<ng-template #s3Accelerator>
  <ng-container
    *ngIf="
      _storageAccount?.supportedS3Accelerator && (createNew?.value || currentBucket() || _storageAccount.isPrivateStorage || blockForm)
    ">
    <div class="mbs-form-group">
      <ng-container *ngIf="!createNew?.value && currentBucket() && currentBucket()?.s3AcceleratorEnabled === null; else switcher">
        <div class="fw-bold">{{ 'shared:modals.addDestinationBucket.s3AcceleratorTitle' | i18next }}</div>
        <div>
          {{ 'shared:modals.addDestinationBucket.s3AcceleratorDisabledByPolicy' | i18next: { type: bucketTypeName } }}
        </div>
      </ng-container>

      <ng-template #switcher>
        <mbs-switcher
          [attr.data-e2e]="e2eLocators.s3AcceleratorControl"
          [boldLabel]="true"
          [formControl]="s3AcceleratorControl"
          [label]="'shared:modals.addDestinationBucket.s3AcceleratorTitle' | i18next">
          <ng-template switcherDescription>
            <div class="add-destination-form_switcher-description text-sm">
              <span class="mr-2">{{
                'shared:modals.addDestinationBucket.s3AcceleratorDescription' | i18next: { type: bucketTypeName }
              }}</span>
              <a
                *ngIf="permissionsEnum.HelpMarketing | can: 'read'"
                target="_blank"
                [href]="'https://docs.aws.amazon.com/AmazonS3/latest/userguide/transfer-acceleration.html#transfer-acceleration-why-use'"
                >{{ 'shared:buttons.learnMore' | i18next }}</a
              >
            </div>
          </ng-template>
        </mbs-switcher>
      </ng-template>
    </div>
  </ng-container>
</ng-template>

<ng-template #reuseAccountRulesTemplate>
  <ng-container *ngIf="_storageAccount?.accountAzureLifecycleRule">
    <ng-container
      *ngIf="
        createNew?.value ||
        (currentBucket()?.bucketName && currentBucket()?.bucketName !== destination?.bucket?.bucketName) ||
        isManualBucketEntering()
      ">
      <div class="mbs-form-group">
        <mbs-switcher
          [attr.data-e2e]="e2eLocators.reuseAccountRulesControl"
          [boldLabel]="true"
          [formControl]="reuseAccountRules"
          [label]="'shared:modals.addDestinationBucket.reuseStorageRules' | i18next">
        </mbs-switcher>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #companies>
  @if (!hideCompanies) {
    <div class="mbs-form-group">
      <h5
        class="mb-0"
        [class.text-disabled]="destination?.isReadOnly">
        {{ 'shared:common.companies' | i18next: { format: 'title' } }}
      </h5>
      <div
        class="mb-2"
        [class.text-disabled]="destination?.isReadOnly">
        {{ 'shared:modals.addDestinationBucket.companyExplanation' | i18next }}
      </div>

      <mbs-companies-picker
        [allowEmptySelection]="true"
        [companiesControl]="companiesControl"
        [disabled]="companiesLocked || destination?.isReadOnly"
        [selectedIds]="selectedCompanyIds"></mbs-companies-picker>
    </div>
  }
</ng-template>

<ng-template #olMismatch>
  <div>
    {{ 'shared:modals.addDestinationBucket.olMismatch' | i18next: { days: currentBucket().objectLockPeriodDays } }}
  </div>
</ng-template>
